import { isNull } from 'lodash'

export const getCookieLanguageCode = (req, app, redirect, store, route) => {
  // 获取语言取值
  // console.log(route, 77)
  const LanguageCode = 'LanguageCode'
  if (app.$cookies.get(LanguageCode)) {
    // 默认有cookie值取cookie的
    return route.fullPath != '/' ? redirect(302, `/${app.$cookies.get(LanguageCode)}/404.html`) : redirect(302, `/${app.$cookies.get(LanguageCode)}`)
  } else {
    const arr = req.headers['user-agent'] && req.headers['user-agent'].split('|')[1] ? req.headers['user-agent'].split('|')[1].split(',') : []
    const arrLan = arr[0]
    if (arrLan) {
      // 没有cookie值优先去cdn返回
      const lang = arrLan.split(':')[1]
      // app.$cookies.set(LanguageCode, lang, { path: '/', domain: hostS })
      return route.fullPath != '/' ? redirect(302, `/${lang}/404.html`) : redirect(302, `/${lang}`)
    }
    if (!arrLan) {
      // 加一个判断取浏览器语言判断是否有对应语言，没有取en
      const { langList = [] } = store.state
      // langList = langList ? langList : []
      const [browserLang] = [req?.headers['accept-language']?.split(',')[0]?.toLowerCase()] // 获取浏览器地址栏参数、获取浏览器的语言
      const [isBrowser] = [langList?.includes(browserLang)] // 浏览器地址栏的语言是否存在于语言列表中、浏览器语言是否存在于语言列表中
      const lang = isBrowser ? browserLang : 'en' // 设定的语言
      return route.fullPath != '/' ? redirect(302, `/${lang}/404.html`) : redirect(302, `/${lang}`)
    }
  }
}

export const getCookieCountryCode = async (req, app) => {
  // 获取国家取值
  const CountryCode = 'CountryCode'
  if (app.$cookies.get(CountryCode)) {
    // 取国家
    return app.$cookies.get(CountryCode)
  } else {
    const arr = req.headers['user-agent'] && req.headers['user-agent'].split('|')[1] ? req.headers['user-agent'].split('|')[1].split(',') : []
    const arrCoun = arr[1]
    if (arrCoun && arrCoun.split(':')[1]) {
      // const country = arrCoun.split(':')[1] ? arrCoun.split(':')[1] : 'us'
      // app.$cookies.set(CountryCode, country, { path: '/', domain: hostS })
      return arrCoun.split(':')[1] ? arrCoun.split(':')[1] : 'us'
    } else {
      // console.log(req.headers['x-forwarded-for'], 11123)
      // console.log(req.headers['x-forwarded-for'], 3868)
      const forwardedIp = req.headers['x-forwarded-for'] ? req.headers['x-forwarded-for'].split(',')[0] : '114.114.114.114'
      const userIp = await app.$axios.get(`http://ipinversion.fxeyeinterface.com/api/v1/getipgeo?ip=${forwardedIp}&uparm2=web202`).catch(() => {
        // 用户ip语言
        console.log('getipgeo', 989)
      })
      // console.log(userIp, 33321)
      const country = userIp && userIp.data && userIp.data.data && userIp.data.data.country_code ? userIp.data.data.country_code : 'cn'
      // app.$cookies.set(CountryCode, country.toLowerCase(), { path: '/', domain: hostS })
      return country
    }
  }
}

export const debounce = (fn, delay) => {
  // 防抖----多次快速点击提交后只会执行一次
  // 设置time为定时器
  let time = null
  // 闭包原理，返回一个函数
  return function (e) {
    // 如果定时器存在则清空定时器
    if (time) {
      clearTimeout(time)
    }
    // 设置定时器，规定时间后执行真实要执行的函数
    time = setTimeout(() => {
      // 此箭头函数里的this指向btn这个按钮
      fn.call(this, arguments) // 改变真实要执行函数的this指向，原submit函数里面的this指向window
    }, delay)
  }
}

/***
 * 节流函数 在wait间隔时间内不再进行任何调用时，触发一次最后的调用（如:wait设置为300ms，一直点击，该函数一直不执行，只有在间隔了300ms不做任何点击后，才执行刚才的最后一次点击）
 * @ func 执行函数
 * @ wait 等待时间
 * @ {Boolean} mustRun 是否立即执行
 * @return {Function}
 */
export const throttle = (func, wait, mustRun) => {
  console.log(func, wait, mustRun, 123)
  // console.log('节流')
  let timeout
  let startTime = new Date()

  return function () {
    const context = this
    const args = arguments
    const curTime = new Date()

    clearTimeout(timeout)
    // 如果达到了规定的触发时间间隔，触发 handler
    if (curTime - startTime >= mustRun) {
      console.log(123)
      func.apply(context, args)
      startTime = curTime
      // 没达到触发间隔，重新设定定时器
    } else {
      console.log(456)
      timeout = setTimeout(func, wait)
    }
  }
}

export const iPhone = (req) => {
  // 判断pc还是移动-服务端判断false为pc；true为m站---参数为服务端req参数
  const userAgentInfo = req.headers['user-agent']
  const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod', 'FXEYE-BIB-IOS-WIKIFX', 'FXEYE- -ANDROID-WIKIFX']
  let flag = false
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo && userAgentInfo.includes(Agents[v])) {
      flag = true
      break
    }
  }
  return flag
}

export const isH5ByAgent = (agent) => {
  if (isNull(agent)) return
  const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod', 'FXEYE-BIB-IOS-WIKIFX', 'FXEYE- -ANDROID-WIKIFX']
  let flag = false
  for (let v = 0; v < Agents.length; v++) {
    if (agent && agent.includes(Agents[v])) {
      flag = true
      break
    }
  }
  return flag
}

export const yUnit = (value) => {
  const intValue = Number(value)
  if (typeof value === 'number') value = value.toString()
  const len = value.length
  if (len <= 6) {
    return intValue
  } else if (len >= 7 && len <= 9) {
    return intValue / 1000000 + 'M'
  } else if (len >= 10 && len <= 12) {
    return intValue / 1000000000 + 'B'
  } else {
    return intValue / 1000000000000 + 'T'
  }
}

export const GetBasicData = (isWiki, mycountry, bfp) => {
  let base = '999,0,2,999,0,' + bfp + ',0'

  if (base && isWiki == '1') {
    base = '999,0,2,999,0,' + bfp + ',0'
  } else if (mycountry == 'cn') {
    base = '999,0,1,225,1,' + bfp + ',1'
  } else {
    base = '999,0,2,999,0,' + bfp + ',0'
  }
  return base
}

export const getUrlState = (imgurl) => {
  // 判断图片链接是否可以访问
  return new Promise(function (resolve, reject) {
    const ImgObj = new Image()
    ImgObj.src = imgurl
    ImgObj.onload = function (res) {
      resolve(res)
    }
    ImgObj.onerror = function (err) {
      reject(err)
    }
  })
}

export const gatClick = () => {
  // 搜索点击统计
  try {
    window.gtag('event', 'click', {
      event_category: 'search',
      event_label: 'search broker'
    })
  } catch (err) {}
}

export const wikifxsearchGat = () => {
  // wikifx下的Pixel统计---搜索统计
  if (!window._tfa) {
    window._tfa = window._tfa || []
  }
  window._tfa.push({ notify: 'event', name: 'search', id: 1480928 })
}

export const wikifxtraderGat = () => {
  // wikifx下的Pixel统计---交易商详情页
  if (!window._tfa) {
    window._tfa = window._tfa || []
  }
  window._tfa.push({ notify: 'event', name: 'brokerpage', id: 1480928 })
}

export const setImg = (bool) => {
  // 图片懒加载图片处理bool为true滚动出发，false默认
  if (!document || !window) return
  const ele = document.getElementsByClassName('common-img')
  const windowHeight = window.innerHeight
  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
  if (ele) {
    for (let i = 0; i < ele.length; i++) {
      if (bool) {
        ele[i].setAttribute('src', ele[i].getAttribute('xsrc'))
      } else {
        const top = ele[i].offsetTop > 100 ? ele[i].offsetTop : ele[i].parentNode.offsetTop
        if (top > 300 && top <= windowHeight + scrollTop) {
          ele[i].setAttribute('src', ele[i].getAttribute('xsrc'))
        }
      }
      const image = new Image()
      image.src = ele[i].getAttribute('xsrc')
      image.onerror = function (e) {
        // console.log(e);
        ele[i].setAttribute('src', ele[i].getAttribute('dg'))
      }
    }
  }
}

// 6位Hex色值转化为rgba
/**
 * 强退 清除用户相关
 * @param {*} color 颜色
 * @param {*} opacity 透明度*10
 */
export const HexToRGB = (color, opacity) => {
  let newColor = 'rgba('
  if (color.length === 4) {
    const arry = []

    for (let i = 1; i < color.length; i++) {
      arry.push(parseInt('0x' + color[i] + color[i]))
    }

    arry.forEach(function (item) {
      newColor += item + ', '
    })
    newColor += opacity / 100 + ')'

    return newColor
  } else {
    const arry = []

    for (let i = 1; i < color.length; i += 2) {
      arry.push(parseInt('0x' + color.slice(i, i + 2)))
    }

    arry.forEach(function (item) {
      newColor += item + ', '
    })
    newColor += opacity / 100 + ')'

    return newColor
  }
}

export const tradername = (name1, name2) => {
  // 设置交易商名称显示name1-英文简称；name2-本地语种简称
  let name = ''
  if (name1 === name2) name = name1
  if (name1 !== name2) name = name1 + ' ' + name2
  return name && name.trim()
}

export const readCount = (num) => {
  // 中文视频知识热度
  num = Number(num) * 11
  let count = '50%'
  if (num == 0) count = '5%'
  else if (num < 201) count = '30%'
  else if (num < 301) count = '40%'
  else if (num < 501) count = '50%'
  else if (num < 801) count = '60%'
  else if (num < 1001) count = '70%'
  else if (num < 1501) count = '80%'
  else if (num < 2001) count = '90%'
  else count = '100%'
  return count
}

export const setten = (num) => {
  // 设置万
  if (num >= 10000) {
    return (num / 10000).toFixed(2) + '万'
  } else {
    return num
  }
}

export const thousand = (num) => {
  // 千位逗号分隔
  return (num + '').replace(/\d(?=(\d{3})+$)/g, '$&,')
}

/**
 * 布尔值统一转 1 0
 * @param data
 * @returns {string|*}
 */
export const boolToString = (data) => {
  if (typeof data !== 'boolean') return data
  return data ? '1' : '0'
}

export const stringDeal = (data) => {
  if (data === null || data === undefined) return ''
  return data
}

/**
 * 对象的key全部赚大小写
 * @param ob
 * @param type
 * @returns {{}|{}}
 */
export const objectKeyToLow = (ob, type = 'low') => {
  if (typeof ob !== 'object') throw new Error(`attributes is not obj: ${ob}`)
  return Object.keys(ob).length > 0
    ? Object.keys(ob).reduce((prev, cur, i) => {
        // 对象值布尔值统一转 1 0
        ob[cur] = boolToString(ob[cur])
        // null 和 undefined 转 ''
        ob[cur] = stringDeal(ob[cur])
        // 对象key 转大小写
        prev[type === 'low' ? cur.toLocaleLowerCase() : cur.toLocaleUpperCase()] = ob[cur]
        return prev
      }, {})
    : {}
}

// 生成UUID全局唯一标识符
export function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0
    const v = c == 'x' ? r : (r & 0x3) | 0x8
    return v?.toString(16)
  })
}

// 搜索场景[场景 1:首页 2:交易商详情页 3:社区页 4:社区内容详情页 5:服务商详情页 6:企业详情页.]
export const GetSearchScene = (routename) => {
  const disListArr = ['discover.html', 'lang-information-id', 'lang-discover-sort-id'] // 社区列表
  const disDetailArr = ['lang-discover-id', 'lang-discover-category-id'] // 社区详情
  if (!routename) return 1
  if (routename == 'HomeIndex' || routename == 'lang') {
    return 1
  } else if (routename === 'lang-dealer-id') {
    return 2
  } else if (disListArr.includes(routename)) {
    return 3
  } else if (disDetailArr.includes(routename)) {
    return 4
  } else if (routename === 'lang-service-id') {
    return 5
  } else {
    return 0
  }
}

// 获取社区(商业+动态)帖子详情页(dataType=帖子类型, postid=帖子id, userid=发帖人id, lan=用户选择语言 postlan=帖子语言)
export const GetDiscoverLinkUrl = (dataType, postid, userid, lan, postlan, wwwhost) => {
  if (dataType) {
    let link = 'discover'
    const subtype = dataType || 3
    switch (subtype) {
      case 1: // 文章数据
        link = 'discover/article'
        break
      case 2: // 曝光数据
        link = 'discover/exposure'
        break
      case 3: // 发现数据
        link = 'discover'
        break
      case 5: // 实勘
        link = 'discover/survey'
        break
      case 6: // 调解
        link = 'discover/mediate'
        break
      case 7: // 快讯数据
        link = 'discover/flash'
        break
      case 8: // 监管披露
        link = 'discover/disclosure'
        break
      case 9: // 评价
        link = 'discover/comment'
        break
    }
    let parm = ''
    if (userid && typeof userid != 'undefined' && userid !== 'undefined' && userid.trim() !== '') {
      parm = `?userid=${userid}`
    }
    if (postlan && typeof postlan != 'undefined' && postlan !== 'undefined' && postlan.trim() !== '') {
      parm += parm ? `&lang=${postlan.toLowerCase()}` : `?lang=${postlan.toLowerCase()}`
    }
    return `${wwwhost}/${lan}/${link}/${postid}.html${parm}`
  }
}
